import { render, staticRenderFns } from "./PdpMainInfo.vue?vue&type=template&id=23b658f7&"
import script from "./PdpMainInfo.vue?vue&type=script&lang=js&"
export * from "./PdpMainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppCampaignIcons: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppCampaignIcons.vue').default,PdpTilesForColor: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpTilesForColor.vue').default,PdpYotpoRating: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpYotpoRating.vue').default})
